import ExpenseCategoryService from '@/services/ExpenseCategoryService';
// state
const localState = {
  autoLoad: {
    loading: false,
    loader: ExpenseCategoryService.getAll,
    emptyMap: {}
  },
  expense_categories: {},
  payments: {}
};

// getters
const localGetters = {};

// mutations
const mutations = {
};

// actions
const actions = {};

export default {
  state: localState,
  getters: localGetters,
  mutations,
  actions,
};
